import {
	getCarData,
	getFuzzySearchData,
	getVariantList,
} from "../_actions/car.actions";

export const fetchData = async ({
	searchValue,
	productType,
	subtype,
	setData,
}: FetchFuzzysearchDataProps) => {
	const data = await getFuzzySearchData({ searchValue, productType, subtype });
	if (setData) setData(data);
	return data;
};

export const fetchVariantList = async ({
	manufacturer,
	model,
	setData,
}: FetchVariantListProps) => {
	const data = await getVariantList({ manufacturer, model });
	if (setData) setData(data);
	return data;
};

export const fetchCarVariantData = async ({
	carVariantId,
	setCarVariantData,
}: FetchCarVariantDataProps) => {
	try {
		const carVariant = await getCarData({ carVariantId });
		if (setCarVariantData) setCarVariantData(carVariant);
		return carVariant;
	} catch (error) {
		console.log(error);
	}
};

export const getGroupedData = ({ data, setData }: GetGroupedDataProps) => {
	const grouped = data.reduce<Record<VehicleType, Record<string, string[]>>>(
		(acc, { type, manufacturer, model }) => {
			const normalizedType = type?.toLowerCase() as VehicleType;

			// ensure top-level bucket exists (car / mobile)
			if (!acc[normalizedType]) acc[normalizedType] = {};

			// ensure manufacturer array exists
			if (!acc[normalizedType][manufacturer])
				acc[normalizedType][manufacturer] = [];

			// add model if it’s not already present
			if (!acc[normalizedType][manufacturer].includes(model)) {
				acc[normalizedType][manufacturer].push(model);
			}

			return acc;
		},
		{ car: {}, mobile: {} } as Record<VehicleType, Record<string, string[]>>,
	);

	setData(grouped);
};
